import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      version="1.1"
      viewBox="0 0 8.467 8.467"
    >
      <g
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.163"
      >
        <path d="M6.908.56a.156.156 0 00-.135.08l-.754 1.303a515.647 515.647 0 00-.09.157l-.44.762.844 1.46L8.459.64a.052.052 0 00-.045-.078H6.908zm-1.67 2.736a319.628 319.628 0 00-.009.016l-.116.201v.001a319.628 319.628 0 00-.054.094l-.072.124.844 1.46.045-.078.08-.14.126-.217-.844-1.46zm-.502.87l-.206.357a.156.156 0 000 .157l.753 1.304a.052.052 0 00.09 0l.207-.357-.844-1.46z"></path>
        <path d="M3.386 2.457a.08.08 0 00-.07.12l.848 1.468a.08.08 0 00.14 0l.846-1.467a.08.08 0 00-.07-.121z"></path>
        <path d="M1.147 2.457a.052.052 0 00-.045.078L4.188 7.88a.052.052 0 00.09 0l.754-1.304a.156.156 0 000-.156l-.754-1.305a1279.74 1279.74 0 01-.09-.156l-.78-1.351a2780.708 2780.708 0 01-.09-.157l-.53-.916a.156.156 0 00-.135-.078z"></path>
        <path d="M.052.56a.052.052 0 00-.045.08l.754 1.303a.156.156 0 00.135.078H5.38a.156.156 0 00.136-.078L6.27.64a.052.052 0 00-.045-.078z"></path>
      </g>
    </svg>
  );
}

export default Icon;
